module.exports = __webpack_public_path__ + "img/taiwanHighSpeedRail-3.0ae08074.jpg";